import initMap from './common/initMap';
import BreakpointsEnum from './enums/breakpointsEnum';
import 'slick-carousel';
import {mapObserver} from './observers/lazyLoading';

require('./modals/write-us');

let App = window.App;
App.contacts = {};

let $locationsSlider = $('.locations');

App.contacts.onMapLoad = function () {
    initMap('map');
}

$(window).on('load resize orientationchange', function () {
    if (window.App.getBreakpoint() === BreakpointsEnum.mobile && !$locationsSlider.hasClass('slick-initialized')) {
        $locationsSlider.slick({
            arrows: false,
            dots: true,
            infinite: false,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [{
                breakpoint: 767,
                settings: 'unslick'
            }]
        });
    }
});

mapObserver.observe($('#map')[0]);